import { interpolate as L } from "./strings.js";
import { isEmpty as U } from "./tools.js";
const M = {
  CLAMP: "clamp",
  CLIP: "clip",
  CROP: "crop",
  FACEAREA: "facearea",
  FILL: "fill",
  FILLMAX: "fillmax",
  MAX: "max",
  MIN: "min",
  SCALE: "scale"
}, w = {
  COVER: "cover",
  CONTAIN: "contain",
  INSIDE: "inside",
  OUTSIDE: "outside"
}, k = {
  JPEG: "jpeg",
  SVG: "svg",
  PNG: "png",
  WEBP: "webp",
  AVIF: "avif"
};
let y = "https://elantil.imgix.net/{{filename_disk}}";
function G(t) {
  y = t;
}
function C(t) {
  if (t)
    return f(t);
}
function S(t) {
  if (!(!t || !t.width || !t.height))
    return `${t.width} / ${t.height}`;
}
function z(t, i, o = {}) {
  const n = C(t) ?? "", r = C(i) ?? "", e = {
    src: {
      mobile: f(n, o),
      desktop: f(r, o)
    },
    aspectRatios: {
      mobile: S(t),
      desktop: S(i)
    }
  }, a = {
    "--background-desktop": e.src.desktop ? `url(${e.src.desktop})` : void 0,
    "--background-mobile": e.src.mobile ? `url(${e.src.mobile})` : void 0,
    "--aspect-ratio-desktop": e.aspectRatios.desktop,
    "--aspect-ratio-mobile": e.aspectRatios.mobile
  };
  return { image: e, styles: a };
}
const c = /* @__PURE__ */ new Map(), x = {
  imgix: /* @__PURE__ */ new Map([
    ["width", "w"],
    ["height", "h"],
    ["fit", "fit"],
    ["format", "fm"],
    ["focalPointX", "fp-x"],
    ["focalPointY", "fp-y"],
    ["quality", "q"],
    ["auto", "auto"]
  ]),
  directus: /* @__PURE__ */ new Map([
    ["width", "width"],
    ["height", "height"],
    ["fit", "fit"],
    ["format", "format"],
    ["quality", "quality"]
  ])
}, f = (t, i = {}) => {
  let o = !1;
  const n = i.imageResizeProvider === "imgix" ? M.CROP : w.COVER;
  (i.fit && i.imageResizeProvider === "imgix" && !Object.values(M).includes(i.fit) || i.fit && i.imageResizeProvider === "directus" && !Object.values(w).includes(i.fit)) && (o = !0);
  const {
    imageBaseUrl: r = y,
    imageResizeProvider: e,
    width: a,
    height: l,
    format: m = k.WEBP,
    focalPointX: d,
    focalPointY: u,
    quality: g,
    auto: p = "format"
  } = i, h = o ? n : i.fit, s = JSON.stringify({
    src: t,
    imageBaseUrl: r,
    imageResizeProvider: e,
    width: a,
    height: l,
    fit: h,
    format: m,
    focalPointX: d,
    focalPointY: u,
    quality: g,
    auto: p
  });
  if (c.has(s))
    return c.get(s);
  const A = U(t) ? void 0 : typeof t != "string" ? L(r, t) : t;
  if (!A)
    return "";
  const P = new URL(A), R = e === "imgix" ? x.imgix : x.directus;
  Object.entries({
    width: a,
    height: l,
    fit: h,
    format: m,
    focalPointX: d,
    focalPointY: u,
    quality: g,
    auto: p
  }).forEach(([E, v]) => {
    v !== void 0 && R.has(E) && P.searchParams.set(R.get(E), String(v));
  });
  const I = P.toString();
  return c.set(s, I), I;
};
export {
  w as DIRECTUS_IMAGE_FIT,
  k as IMAGE_FORMAT,
  M as IMGIX_IMAGE_FIT,
  f as generateOptimizedImageUrl,
  S as getAspectRatio,
  C as getAssetURL,
  z as getResponsiveImageWithStyles,
  G as setAssetBaseUrl
};
